var _g, _circle, _path, _path2, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 491,
    height: 649,
    viewBox: "0 0 491 649",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1325_7269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.462 616C188.393 616 236.479 603.816 278.962 582.204M253.962 13.4382C276.363 22.4438 297.48 33.969 316.962 47.6632",
    stroke: "#0C00FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 322.962 555.001)",
    fill: "#0C00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451.274 292.195C455.662 279.46 448.334 265.674 435.323 262.188L88.0207 169.129C75.0097 165.642 61.7707 173.917 59.2038 187.14L22.8947 374.181C20.5701 386.156 27.9038 397.89 39.6868 401.047L361.223 487.202C373.006 490.359 385.223 483.865 389.198 472.332L451.274 292.195Z",
    fill: "#F5F6F8",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 4.22367
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M466.378 181.963C469.698 169.57 462.344 156.832 449.951 153.512L333.933 122.425C324.217 119.821 314.229 125.588 311.625 135.304C308.418 147.274 296.114 154.378 284.144 151.171L126.309 108.879C113.916 105.558 101.178 112.912 97.8577 125.305L93.895 140.094C92.3856 145.727 95.7285 151.517 101.361 153.026L106.971 154.529C109.506 155.209 112.111 153.704 112.791 151.17C114.074 146.382 118.995 143.54 123.783 144.823L423.645 225.171C428.433 226.454 431.274 231.375 429.991 236.163C429.312 238.698 430.816 241.304 433.351 241.983L438.961 243.486C444.594 244.995 450.384 241.652 451.893 236.019L466.378 181.963Z",
    fill: "#F5F6F8",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 4.22367
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1325_7269)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.164 313.932C269.144 315.099 268.452 317.682 269.618 319.702L283.485 343.719L259.468 357.586C257.447 358.752 256.755 361.335 257.922 363.355C259.088 365.375 261.671 366.068 263.691 364.901L291.366 348.923C293.387 347.757 294.079 345.173 292.912 343.153L276.934 315.478C275.768 313.458 273.185 312.766 271.164 313.932Z",
    fill: "url(#paint0_linear_1325_7269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.961 321.814C263.628 317.773 265.012 312.607 269.053 310.274C273.093 307.942 278.259 309.326 280.592 313.366L296.57 341.041C298.903 345.082 297.518 350.248 293.478 352.581L265.803 368.559C261.763 370.892 256.596 369.507 254.264 365.467C251.931 361.427 253.315 356.26 257.356 353.928L277.715 342.173L265.961 321.814Z",
    stroke: "url(#paint1_linear_1325_7269)",
    strokeWidth: 8.44734
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1325_7269)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.454 297.933C210.288 295.913 207.705 295.221 205.684 296.387L178.009 312.365C175.989 313.531 175.297 316.115 176.463 318.135L192.442 345.81C193.608 347.83 196.191 348.522 198.211 347.356C200.231 346.19 200.924 343.606 199.757 341.586L185.891 317.569L209.908 303.702C211.928 302.536 212.62 299.953 211.454 297.933Z",
    fill: "url(#paint2_linear_1325_7269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.112 295.821C212.779 291.781 207.613 290.396 203.573 292.729L175.898 308.707C171.857 311.04 170.473 316.206 172.806 320.247L188.784 347.922M215.112 295.821L188.784 347.922M215.112 295.821C217.445 299.861 216.06 305.028 212.02 307.36L191.66 319.115L203.415 339.474C205.748 343.515 204.363 348.681 200.323 351.014C196.283 353.346 191.116 351.962 188.784 347.922M215.112 295.821L188.784 347.922",
    stroke: "url(#paint3_linear_1325_7269)",
    strokeWidth: 8.44734
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1325_7269)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.542 279.843C233.21 279.804 231.288 281.663 231.248 283.995L229.681 377.151C229.642 379.483 231.501 381.405 233.833 381.445C236.166 381.484 238.088 379.625 238.127 377.293L239.694 284.138C239.734 281.805 237.875 279.883 235.542 279.843Z",
    fill: "url(#paint4_linear_1325_7269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.025 283.924C227.104 279.26 230.949 275.542 235.613 275.62C240.278 275.699 243.996 279.544 243.917 284.209L242.35 377.364C242.272 382.028 238.427 385.746 233.762 385.668C229.098 385.589 225.38 381.744 225.458 377.08L227.025 283.924Z",
    stroke: "url(#paint5_linear_1325_7269)",
    strokeWidth: 8.44734
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1325_7269",
    x: 114.462,
    y: 0.437744,
    width: 225.5,
    height: 648.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1325_7269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1325_7269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1325_7269",
    x: 226.732,
    y: 293.302,
    width: 97.37,
    height: 113.348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.5592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0871
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1325_7269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1325_7269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1325_7269",
    x: 145.274,
    y: 275.756,
    width: 97.3695,
    height: 113.348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.5592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0871
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1325_7269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1325_7269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1325_7269",
    x: 199.059,
    y: 259.78,
    width: 71.2577,
    height: 162.846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.5592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0871
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1325_7269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1325_7269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1325_7269",
    x1: 285.283,
    y1: 316.435,
    x2: 271.4,
    y2: 368.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1325_7269",
    x1: 285.283,
    y1: 316.435,
    x2: 271.4,
    y2: 368.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1325_7269",
    x1: 197.976,
    y1: 293.041,
    x2: 184.093,
    y2: 344.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1325_7269",
    x1: 197.976,
    y1: 293.041,
    x2: 184.093,
    y2: 344.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1325_7269",
    x1: 247.478,
    y1: 282.91,
    x2: 221.898,
    y2: 378.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1325_7269",
    x1: 247.478,
    y1: 282.91,
    x2: 221.898,
    y2: 378.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.b64cf3d8272723ea46b7f87226e368b5.svg";
export { ForwardRef as ReactComponent };